import React from 'react';
import { useQuery } from '@apollo/client';
import dayjs from 'dayjs';

import '../css/home.css';
import { USERS } from '../apollo/user/userQuery';
import { toast } from 'react-toastify'; //? React-Toastify
import Spinners from './spinner/Spinners';

function Home() {
  //! USERS
  const { loading, data } = useQuery(USERS, {
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  if (loading) return <Spinners />;
  const Data = data?.users?.payload;
  // ####################################################
  return (
    <div className='container my-5 home'>
      <div className='row'>
        {Data?.map((item, i) => {
          return (
            <div className='container' key={i}>
              <div>
                {item?.quotes?.map((el, index) => {
                  return (
                    <div className='outerCard mt-4' key={index}>
                      <div className='card-header '>
                        <strong>Quote</strong>
                        <div className='float-end'>
                          <strong>{dayjs(parseInt(el?.createdAt)).format('DD-MM-YYYY')}</strong>
                        </div>
                      </div>
                      <div className='card'>
                        <div className='card-body'>
                          <h5 className='card-title'>{el?.quote}</h5>
                          <p className='card-text float-end'>~{item?.name}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Home;
